/* eslint-disable max-len */
import React, {useState, useContext, useCallback} from 'react'
import { PriceHandler, TitleCase } from '../../../redux/helper/CamelCase'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { CDN } from '../../../constants'
import AddToCart from '../../../Components/AddtoCartModal'
import HeaderContext from '../../../Components/Context/HeaderContext'
import CategoryToolTip from '../../../Components/CategoryToolTip'

const RecentlyOrderedProducts = ({orderProducts}) => {
    const [CartId, setCartId] = useState({})
    const [Cart, setCart] = useState([]);
    const [hover, sethover] = useState(-1);
    const [viewMore, setViewMore] = useState(true);
    const {
        SetErrorMessage,
        colorValue,
        setcolorValue, } = useContext(HeaderContext);
    const handleError=(related)=>{
        SetErrorMessage(related?.message);
        setcolorValue(!colorValue);
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
        }, 1000);
    }
    const handleFetch =  () => {return null}
    const handleImage = (img)=> img?`${CDN}/product-images/${img}`:'/images/gen.png';
    return (
        <div className="sm:px-5 px-3 sm:py-5 py-3 mt-[13px] bg-[#F5F5FA] rounded-lg">
            <div className=" text-start ">
                <p className="sm:text-xs10 text-lg font-semibold text-[#090406]"> Recently Ordered Products</p>
            </div>
            <div className="flex flex-wrap sm:-mx-4 -mx-2">
                {orderProducts.filter((month,idx) => idx < (viewMore === true ?3:5)).map((Product,index)=> (
                    <div className="xl:w-[33.3%] lg:w-[33.3%] md:w-[50%] w-full sm:px-4 px-2" key = {`recentProducts${index}`}>
                        <div className="pt-[18px] h-full">
                            <div className="rounded-lg bg-[#FFFFFF] shadow-s7 pt-2 sm:pb-2.5 pb-2 sm:pl-3 sm:pr-4 px-2.5 relative h-full flex flex-col justify-between"> 
                                <div>
                                    <div className="flex justify-between w-full">
                                        <div className="w-[50%]">
                                            <Link to={`/products/${Product.INVENTORY_ITEM_ID}/view`}>
                                                <motion.img initial={{ opacity: 0, scale: 0.6 }}
                                                    animate={{ opacity: 1, scale: 1 }}
                                                    transition={{
                                                        duration: 0.8,
                                                        delay: 0.5,
                                                        ease: [0, 0.71, 0.2, 1.01]
                                                    }} src={handleImage(Product?.IMAGE_NAME)} alt="icon" className="w-full" />
                                            </Link> 
                                        </div>
                                        <div className="pl-5  w-[50%] pr-1">
                                            <div className="flex sm:items-center items-start sm:flex-row flex-col">
                                                <p className=" text-sm56 font-bold text-[#090406] md:pt-0 sm:pt-[60px] pt-3 ">{Product?.MODEL_DESCRIPTION || `${Product?.DESCRIPTION.length > 20 ? `${Product.DESCRIPTION.slice(0,20)}...`:`${Product.DESCRIPTION}`}`}</p>
                                            </div>
                                            <div className="flex  w-fit items-center md:mx-auto">
                                                <p className="text-xs font-semibold text-[090406]">Category</p>
                                                <p className="text-xs3 font-semibold text-white px-1 bg-[#555259] rounded-[3px] w-fit mx-1.5">{Product?.DELIVERY_LEAD_TIME && TitleCase(Product?.DELIVERY_LEAD_TIME)}</p>
                                                <img src="/images/info_icon1.svg" alt="icon" className="cursor-pointer pr-1.5 w-[20px]" onMouseEnter={()=>sethover(index)} onMouseLeave={()=>{
                                                    setTimeout(() => {
                                                        sethover(-1)
                                                    }, 2000);
                                                }}/>
                                                {hover == index && (
                                                    <CategoryToolTip hover={true}/>
                                                )}
                                            </div>
                                        </div>
                            
                                
                                    </div> 
                                </div>
                                <div>
                                    <div className=" mb-2 pl-4 flex sm:items-center items-baseline sm:flex-row flex-col">
                                        <p className="text-xs  font-semibold text-[#808285] sm:px-2 sm:border-r sm:border-[#707070] sm:pt-0 pt-1">Product Code: {Product?.CONCATENATED_SEGMENTS}</p>
                                        <p className="text-xs font-semibold text-[#808285] sm:pl-2 sm:pt-0 pt-1">{Product?.AWS_CLASSIFICATION === null ? null : `AWS Classification: ${Product?.AWS_CLASSIFICATION}`}</p>
                                
                                    </div>
                                    <div className=" w-full">
                                        <div>
                                            <div className="bg-[#EAEAF0] rounded-md p-4 w-full ">
                                                <div className="flex">
                                                    <div className="w-1/2 pr-1">
                                                        <p className="text-xs font-semibold text-[#616874]">Unit of Measurement</p>
                                                        <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{Product?.PRIMARY_UOM_CODE}</p>
                                                    </div>
                                                    <div className="w-1/2 pr-1">
                                                        <p className="text-xs font-semibold text-[#616874]">Minimum Order Quantity</p>
                                                        <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{Product?.MINIMUM_ORDER_QUANTITY || 1} {Product?.PRIMARY_UOM_CODE}</p>
                                                    </div>
                                                </div>
                                                <div className="flex pt-4">
                                                    <div className="w-1/2 pr-1">
                                                        <p className="text-xs font-semibold text-[#616874]">Standard Pack Size</p>
                                                        <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{Product?.PACKING_SIZE === null ? '1' : Product?.PACKING_SIZE }</p>
                                                    </div>
                                                    <div className="w-1/2 pr-1">
                                                        <p className="text-xs font-semibold text-[#616874]">Size</p>
                                                        <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">
                                                            <>
                                                                <>{`${Product?.DIAMETER!==null ?`${Product?.DIAMETER}mm`:''}`}</>
                                                                <>{`${Product?.LENGTH!==null && Product?.DIAMETER ? 'x':''}`}</>
                                                                <>{`${Product?.LENGTH!==null ?`${Product?.LENGTH}mm`:''}`}</>
                                                                <>{Product?.LENGTH===null && Product?.DIAMETER===null ? '-':''}</>
                                                            </>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-2.5 flex items-center justify-between">
                                        <div className="lg:w-[65%] w-full pl-4">
                                            <p className="sm:text-xs6 text-xs2 font-semibold text-[#808285]">List Price</p>
                                            <p className="md:text-xs11 sm:text-xl text-lg font-semibold text-[#15090E]">{PriceHandler(Product?.LIST_PRICE || 0)}</p>
                                        </div>
                                        <div className="lg:w-[35%] w-full">
                                            <button type="button" className="w-full sm:h-10 h-8 rounded-lg bg-[#555259] text-sm font-semibold text-[#FFFFFF]" data-bs-toggle="modal" data-bs-target="#addtocart"
                                                onClick={()=>setCartId(Product)}>
                                                Add to Cart
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>  
                    </div>
                ))}

                {viewMore === false && 
                <div className="ordered-products-more xl:w-[31.3%] lg:w-[31%] md:w-[45%]  w-full h-[397px] flex items-center justify-center ml-5">
                    <div className=" bg-white rounded-[8px]  mt-5 shadow-7s">
                        <Link to={`/orders`}><button className="text-sm55 py-5 px-5 text-center  font-normal text-black">View All</button> </Link>
                    </div>
                </div>
                }
            </div>
            <div className="w-full bg-white rounded-[8px] flex justify-center view-more-order-products  mt-5 shadow-7s" onClick={()=>setViewMore(!viewMore)}>
                <button className="text-sm55 py-5 text-center  font-normal text-black" >{viewMore? 'View More': 'View Less'}</button>
                <img src="/images/sort-icon-view-more.svg" alt="sort icon" className={`mt-1 ml-2 cursor-pointer ${viewMore === false ?'rotate-180':''}`}/>
            </div>
            <AddToCart product={CartId} isClose={setCartId} handlefetch={handleFetch} Cart={Cart}/>
        </div>
        
    )
}

export default RecentlyOrderedProducts
